import { LeadsByCompany } from "@/pages/Dashboard/Leads/hooks/useDashLead";

export enum LEAD_STATUS {
  Incomplete = "incomplete",
  ReadyToRent = "ready_to_rent",
  Converted = "converted",
  NewLead = "new_lead",
  Archived = "archived",
  Sdr = "sdr",
  UnderNegotiation = "under_negotiation",
  Reproved = "reproved",
  PendingLegalReview = "pending_legal_review"
}

export enum SITUATION_ORIGIN_LEADS {
  EMBAIXADOR = "Embaixador",
  FACEBOOK = "Facebook",
  GOOGLE = "Google",
  INDICACAO = "Indicação",
  INSTAGRAM = "Instagram",
  OLX = "Olx",
  RADIO = "Rádio",
  SITE = "Site",
  TELEVISAO = "Televisão",
  TIKTOK = "TikTok",
  SDR = "SDR",
  UNID_MOVEL = "Unid. Móvel",
}

export type Address = {
  zipcode: string;
  street: string;
  number?: string | number;
  complement?: string;
  city: string;
  state: string;
  district: string;
  latitude?: number; // Geolocalização, opcional
  longitude?: number; // Geolocalização, opcional
};

export type LeadType = {
  _id: string;
  name: string;
  pendencies: PendencyType[];
  status: LEAD_STATUS;
  updatedAt: string;
  createdAt: Date;
};

export type CriminalCheckLead = {
  jus?: boolean;
  escavador?: boolean;
};

export type PendencyType = {
  key: string;
  message: string;
  entityErrors: [
    {
      message: string;
      path: string[];
    }
  ];
};
export type LeadDocuments = {
  type: string;
  content: string;
  file?: unknown;
  verified: boolean;
};

type Pendency = {
  key: string;
  message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityErrors: [any];
};

export type Observation = {
  text: string;
  date: string;
  author: string;
};

export type LeadReference = {
  name: string;
  content: string;
  verified: boolean;
};

export type ILead = {
  _id?: string;

  deleteAt: Date | null;
  name: string;
  createdAt: Date;
  email: string;
  cnh: string;
  cpf: string;
  cpfDoIndicador: string;
  companyId: string;
  whatsapp: string;
  birthDate: string;
  pendencies: Pendency[];
  documents: LeadDocuments[];
  references: LeadReference[];
  address: Address;
  gender: string;
  status: LEAD_STATUS;
  cnhExpirationDate: string;
  typeSanguine: string;
  rg: string;
  rg_orgexp: string;
  motherName: string;
  sequencialCode: number;
  avatar: string;
  criminalCheckLead: CriminalCheckLead;
  observations: Observation[];
  leadOrigin: string;
  technicalConsultant: string;
  sdr: string;
  cpfDoIndicadorOptions: {
    indicated: boolean;
    notIndicated: boolean;
  };
  groupName: string;
  jurValidation: {
    status: boolean;
    validated: boolean;
    details?: string;
  };
  dataPix?: {
    key: string;
    keytype: string;
  };
  negociationSDR?: boolean;
  externalReferences: {
    chat: {
      id: string;
      contactId: string;
      lastMessageAt: Date | undefined;
      isLastMessageFromMe: boolean;
    };
  };
};

export const emptyLead = () =>
({
  _id: "",
  deleteAt: null,
  createdAt: new Date(),
  name: "",
  email: "",
  cnh: "",
  cpf: "",
  cpfDoIndicador: "",
  companyId: "",
  whatsapp: "",
  birthDate: new Date().toUTCString(),
  pendencies: [],
  documents: [],
  references: [],
  address: {
    zipcode: "",
    street: "",
    number: 0,
    complement: "",
    city: "",
    state: "",
    district: "",
    latitude: 0,
    longitude: 0,
  },
  gender: "",
  status: LEAD_STATUS.Incomplete,
  cnhExpirationDate: new Date().toUTCString(),
  typeSanguine: "",
  rg: "",
  rg_orgexp: "",
  motherName: "",
  sequencialCode: 0,
  avatar: "",
  criminalCheckLead: {
    jus: false,
    escavador: false,
  },
  observations: [],
  leadOrigin: "",
  technicalConsultant: "",
  sdr: "",
  cpfDoIndicadorOptions: {
    indicated: false,
    notIndicated: false,
  },
  groupName: "",
  jurValidation: {
    status: false,
    validated: false,
    details: "",
  },
  dataPix: {
    key: "",
    keytype: "",
  },
  negociationSDR: false,
  externalReferences: {
    chat: {
      id: "",
      lastMessageAt: undefined,
      isLastMessageFromMe: true,
      contactId: "",
    },
  },
} as ILead);

export type StatusCounterLead = {
  new_lead: number;
  incomplete: number;
  ready_to_rent: number;
  converted: number;
  archived: number;
  convertedLeads: number;
  under_negotiation: number;
};
export type VibechatMetricResponse = {
  team_id: number;
  team_name: string;
  average_service_time: number;
  agents: {
    agent_id: number;
    agent_name: string;
    attended_conversations: number;
    unfinished_conversations: number;
    avg_resolution_time: number;
    avg_first_response_time: number;
    avg_reply_time: number;
  }[];
};
// export type responseLeadDash = {
//   counts: {
//     archived: number;
//     incomplete: number;
//     ready_to_rent: number;
//     [key: string]: number; // permite mais status no futuro, opcional
//   };
//   total: number;
//   convertedLeads: number;
// };
export type LeadStatusCountsGrouped = {
  tma: number;
  monthGoal: number;
  dailyGoal: number;
  leadsByTime: Record<string, number>;
  filter: {
    counts: Record<string, number>;
    total: number;
  };
  filterToday: {
    counts: Record<string, number>;
    total: number;
  };
  leadsTodayWithoutCity?: number;
  leadsByOrigin: {
    origin: string;
    count: number;
  }[];
  leadsByConsultant: {
    consultant: string;
    count: number;
  }[];
  leadsSixtyDaysAgo: Record<string, number>;
  leadsByCompany: LeadsByCompany[];
  leadsByCompanyFilter: LeadsByCompany[];
};

type LeadStatusCountsListItem = {
  _id: {
    status: string;
  };
  count: number;
};

export type ResponseLeadDash = LeadStatusCountsGrouped | LeadStatusCountsListItem[];
